__turbopack_context__.v({
  "body": "vDEL_a_body",
  "title": "vDEL_a_title",
});
